import React from 'react'
import "./authstyle.scss"

const AuthorizedMessage = () => {
    return (
        <div 
        // style={{
        //     "margin": "auto",
        //     "padding": "10px",
        //     "textAlign": "center",
        //     "padding": "20% 0"
        // }}
        className='authscss'
        >
            <p 
            // style={{
            //     "line-height": "1.5",
            //     "display": "inline-block",
            //     "vertical-align": "middle",
            //     "fontWeight": "bold"
            // }}
            >You are not authorized to access this screen</p>
        </div>
    )
}

export default AuthorizedMessage